// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inventory-management-container .listing-header {
  display: flex;
  justify-content: space-between;
  padding: 0.3125rem 0 1.5625rem 0;
}
.inventory-management-container .listing-header .title-div {
  font-size: 1.75rem;
  font-weight: bold;
  color: var(--ion-color-primary-black);
  text-transform: capitalize;
}
.inventory-management-container .listing-header .search-and-filter {
  display: flex;
  justify-content: flex-end;
}
.inventory-management-container .listing-header .search-and-filter .filter-div {
  display: flex;
}
.inventory-management-container .listing-header .search-and-filter .filter-div .filter-icon {
  display: flex;
  align-items: center;
  padding: 0 0.5625rem;
  cursor: pointer;
}
.inventory-management-container .listing-header .search-and-filter .filter-div .filter-label {
  cursor: pointer;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.0625rem;
  display: flex;
  align-items: center;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: var(--ion-color-primary);
}
.inventory-management-container .listing-header .search-and-filter .filter-div .close-label {
  color: var(--ion-color-primary-black) !important;
}
.inventory-management-container .listing-table {
  padding: 0 0 1.25rem;
  overflow-x: auto;
}
.inventory-management-container .listing-table .table {
  width: 100%;
}
.inventory-management-container .listing-table .table .column-heading {
  font-weight: 400;
  text-align: left;
  font-size: 0.975rem;
  line-height: 1rem;
  text-transform: uppercase;
  color: var(--ion-color-secondary-black);
  padding: 0.75rem 0.625rem;
  border-bottom: 1px solid var(--ion-color-primary-border);
  cursor: pointer;
}
.inventory-management-container .listing-table .table .status-col {
  max-width: 110px;
  width: 100px;
}
.inventory-management-container .listing-table .table .ship-to-col {
  min-width: 100px;
  max-width: 244px;
}
.inventory-management-container .listing-table .table .table-body .table-row td {
  border-bottom: 1px solid var(--ion-color-primary-border);
  padding: 0.5rem 0.625rem;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.1875rem;
  color: var(--ion-color-primary-black);
}
.inventory-management-container .listing-table .table .table-body .table-row td .product-img {
  width: 80px;
}
.inventory-management-container .listing-table .table .table-body .table-row .warehouse-data {
  padding: 0.5rem 0.625rem;
}
.inventory-management-container .listing-table .table .table-body .table-row .right-arrow {
  display: flex;
  align-items: center;
}
.inventory-management-container .mobile-view-listing .order-container .order-card {
  background: var(--ion-color-primary-white);
  border: 1px solid var(--ion-color-primary-border);
  border-radius: 2px;
  margin: 0.625rem 0;
}
.inventory-management-container .mobile-view-listing .order-container .order-card .order-card-col {
  padding-top: 0.9375rem;
}
.inventory-management-container .mobile-view-listing .order-container .order-card .grid-label {
  font-weight: 400;
  font-size: 0.6875rem;
  line-height: 0.8125rem;
  text-transform: uppercase;
  color: var(--ion-color-secondary-black);
}
.inventory-management-container .mobile-view-listing .order-container .order-card .grid-values {
  padding-top: 0.1875rem;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.1875rem;
  color: var(--ion-color-secondary-blue);
}
.inventory-management-container .mobile-view-listing .order-container .mobile-right-arrow {
  display: flex;
  justify-content: center;
  align-items: center;
}

.products-number-div {
  font-weight: bold;
  font-size: 0.875rem;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
  font-size: 0.875rem;
}

.status-btn,
.pending,
.shipped,
.canceled {
  font-weight: 400;
  max-width: 140px;
  font-size: 0.8375rem;
  line-height: 1.125rem;
  border-radius: 4px;
  width: 100%;
  text-transform: capitalize;
}

.pending {
  background: rgba(109, 207, 246, 0.2);
  color: var(--ion-color-primary-blue);
}

.shipped {
  background: rgba(172, 219, 97, 0.25);
  color: var(--ion-color-green-100);
}

.canceled {
  background: rgba(233, 75, 75, 0.1);
  color: var(--ion-color-primary);
}

.shipping,
.partially-shipped {
  background: rgba(255, 121, 23, 0.17);
  color: var(--ion-color-primary-orange);
}

.order-card .status-btn {
  width: auto;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 0.875rem;
}

.justify-end {
  justify-content: flex-end;
}

.justify-centre {
  justify-content: center;
}

.justify-start {
  justify-content: flex-start;
}

.toggle-edit-block ion-toggle {
  --background-checked: var(--ion-color-primary);
  vertical-align: bottom;
}
.toggle-edit-block .edit {
  position: relative;
  top: -2px;
  cursor: pointer;
}
.toggle-edit-block .toggle-block-icons {
  cursor: pointer;
  vertical-align: bottom;
  font-size: 1.25rem;
  height: 20px;
  width: 20px;
}

.mw-70 {
  min-width: 70px;
}

.mw-80 {
  min-width: 80px;
}

.mw-100 {
  min-width: 100px;
}

.mw-120 {
  min-width: 120px;
}

.mw-150 {
  min-width: 150px;
}

.mw-200 {
  min-width: 200px;
}

.button-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.mass-upload-btn {
  width: 140px;
  height: 46px;
  background: var(--ion-color-primary) 0% 0% no-repeat padding-box;
  opacity: 1;
  font-weight: bold;
  font-size: 0.9375rem;
  letter-spacing: 0;
  color: var(--ion-color-primary-white);
  text-transform: uppercase;
  opacity: 1;
}

.generate-template-btn {
  width: 130px;
}

.export-btn,
.update-btn {
  width: 100px;
}

.arrow-icon {
  cursor: pointer;
}

.isOpen img {
  transform: rotate(90deg);
  transition: 0.5s ease-in-out;
}

.isClosed img {
  transform: rotate(270deg);
  transition: 0.5s ease-in-out;
}

.inventory-modal ion-header:after {
  height: 0;
}

.download-arrow img {
  filter: brightness(0) invert(1);
}

.common-input .modal-label {
  font-weight: bold;
}
.common-input .modal-label .value {
  font-weight: 400;
}

.icon-color {
  color: var(--ion-black-primary);
  font-size: 20px;
  vertical-align: bottom;
}

.toggle-container {
  height: 1.25rem;
  cursor: pointer;
}

.subproduct-open {
  color: var(--ion-app-primary);
}

.arrow-column {
  min-width: 30px;
}

.table-input {
  border: 1px solid var(--ion-black-primary);
  z-index: 0;
}

.cursor-disabled {
  cursor: not-allowed;
}

.highlighted-row td {
  background-color: var(--ion-light-grey);
}

.filter-container {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 2.5rem;
  column-gap: 0.9375rem;
  align-items: center;
  width: 100%;
}

.filter-buttons {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  column-gap: 0.625rem;
  row-gap: 0.625rem;
}

.from-date-div,
.to-date-div {
  width: unset;
}

.from-date-class,
.to-date-class {
  max-width: 190px;
}

.to-date-class {
  margin-top: 2rem;
}

.status-label {
  width: 100%;
  padding-bottom: 0.625rem;
  font-weight: bold;
  text-transform: capitalize !important;
  color: var(--ion-color-primary-black);
}

.filter-header {
  padding-bottom: 1.25rem;
}

.filter-header-ng-select {
  min-width: 300px;
}

.cancel-icon {
  width: 20px;
}

@media (max-width: 767px) {
  .inventory-management-container .listing-header .title-div {
    font-size: 1.625rem;
  }
  .from-date-class,
  .to-date-class,
  .status-select-input {
    max-width: 100%;
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/inventory-management/inventory-management.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAGC;EACC,aAAA;EACA,8BAAA;EACA,gCAAA;AAFF;AAIE;EACC,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,0BAAA;AAFH;AAKE;EACC,aAAA;EACA,yBAAA;AAHH;AAKG;EACC,aAAA;AAHJ;AAKI;EACC,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;AAHL;AAMI;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,+BAAA;AAJL;AAOI;EACC,gDAAA;AALL;AAWC;EACC,oBAAA;EACA,gBAAA;AATF;AAWE;EACC,WAAA;AATH;AAWG;EACC,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,uCAAA;EACA,yBAAA;EACA,wDAAA;EACA,eAAA;AATJ;AAYG;EACC,gBAAA;EACA,YAAA;AAVJ;AAaG;EACC,gBAAA;EACA,gBAAA;AAXJ;AAgBK;EACC,wDAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,qCAAA;AAdN;AAgBM;EACC,WAAA;AAdP;AAkBK;EACC,wBAAA;AAhBN;AAmBK;EACC,aAAA;EACA,mBAAA;AAjBN;AA2BG;EACC,0CAAA;EACA,iDAAA;EACA,kBAAA;EACA,kBAAA;AAzBJ;AA2BI;EACC,sBAAA;AAzBL;AA4BI;EACC,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,uCAAA;AA1BL;AA6BI;EACC,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,sCAAA;AA3BL;AA+BG;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;AA7BJ;;AAoCA;EACC,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;EACA,mBAAA;AAjCD;;AAoCA;;;;EAIC,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,0BAAA;AAjCD;;AAoCA;EACC,oCAAA;EACA,oCAAA;AAjCD;;AAoCA;EACC,oCAAA;EACA,iCAAA;AAjCD;;AAoCA;EACC,kCAAA;EACA,+BAAA;AAjCD;;AAqCA;;EAEC,oCAAA;EACA,sCAAA;AAlCD;;AAsCC;EACC,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AAnCF;;AAuCA;EACC,yBAAA;AApCD;;AAuCA;EACC,uBAAA;AApCD;;AAuCA;EACC,2BAAA;AApCD;;AAyCC;EAKC,8CAAA;EACA,sBAAA;AA1CF;AA6CC;EACC,kBAAA;EACA,SAAA;EACA,eAAA;AA3CF;AA8CC;EACC,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AA5CF;;AAgDA;EACC,eAAA;AA7CD;;AAgDA;EACC,eAAA;AA7CD;;AAgDA;EACC,gBAAA;AA7CD;;AAgDA;EACC,gBAAA;AA7CD;;AAgDA;EACC,gBAAA;AA7CD;;AAgDA;EACC,gBAAA;AA7CD;;AAgDA;EACC,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;AA7CD;;AAgDA;EACC,YAAA;EACA,YAAA;EACA,gEAAA;EACA,UAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,qCAAA;EACA,yBAAA;EACA,UAAA;AA7CD;;AAgDA;EACC,YAAA;AA7CD;;AAgDA;;EAEC,YAAA;AA7CD;;AAgDA;EACC,eAAA;AA7CD;;AAiDC;EACC,wBAAA;EACA,4BAAA;AA9CF;;AAmDC;EACC,yBAAA;EACA,4BAAA;AAhDF;;AAqDC;EACC,SAAA;AAlDF;;AAuDC;EACC,+BAAA;AApDF;;AAyDC;EACC,iBAAA;AAtDF;AAwDE;EACC,gBAAA;AAtDH;;AA2DA;EACC,+BAAA;EACA,eAAA;EACA,sBAAA;AAxDD;;AA2DA;EACC,eAAA;EACA,eAAA;AAxDD;;AA2DA;EACC,6BAAA;AAxDD;;AA2DA;EACC,eAAA;AAxDD;;AA2DA;EACC,0CAAA;EACA,UAAA;AAxDD;;AA2DA;EACC,mBAAA;AAxDD;;AA4DC;EACC,uCAAA;AAzDF;;AA6DA;EACC,aAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;AA1DD;;AA6DA;EACC,WAAA;EACA,aAAA;EACA,yBAAA;EACA,oBAAA;EACA,iBAAA;AA1DD;;AA6DA;;EAEC,YAAA;AA1DD;;AA6DA;;EAEC,gBAAA;AA1DD;;AA6DA;EACC,gBAAA;AA1DD;;AA6DA;EACC,WAAA;EACA,wBAAA;EACA,iBAAA;EACA,qCAAA;EACA,qCAAA;AA1DD;;AA6DA;EACC,uBAAA;AA1DD;;AA6DA;EACC,gBAAA;AA1DD;;AA6DA;EACC,WAAA;AA1DD;;ACpNQ;EDkRP;IACC,mBAAA;EA1DA;EA6DD;;;IAGC,eAAA;IACA,WAAA;EA3DA;AACF","sourcesContent":["@import \"src/theme/mixins.scss\";\n\n.inventory-management-container {\n\t.listing-header {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tpadding: 0.3125rem 0 1.5625rem 0;\n\n\t\t.title-div {\n\t\t\tfont-size: 1.75rem;\n\t\t\tfont-weight: bold;\n\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\ttext-transform: capitalize\n\t\t}\n\n\t\t.search-and-filter {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: flex-end;\n\n\t\t\t.filter-div {\n\t\t\t\tdisplay: flex;\n\n\t\t\t\t.filter-icon {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tpadding: 0 0.5625rem;\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t}\n\n\t\t\t\t.filter-label {\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\tline-height: 1.0625rem;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tletter-spacing: 0.3px;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t\t}\n\n\t\t\t\t.close-label {\n\t\t\t\t\tcolor: var(--ion-color-primary-black) !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.listing-table {\n\t\tpadding: 0 0 1.25rem;\n\t\toverflow-x: auto;\n\n\t\t.table {\n\t\t\twidth: 100%;\n\n\t\t\t.column-heading {\n\t\t\t\tfont-weight: 400;\n\t\t\t\ttext-align: left;\n\t\t\t\tfont-size: 0.975rem;\n\t\t\t\tline-height: 1rem;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tcolor: var(--ion-color-secondary-black);\n\t\t\t\tpadding: 0.75rem 0.625rem;\n\t\t\t\tborder-bottom: 1px solid var(--ion-color-primary-border);\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\n\t\t\t.status-col {\n\t\t\t\tmax-width: 110px;\n\t\t\t\twidth: 100px;\n\t\t\t}\n\n\t\t\t.ship-to-col {\n\t\t\t\tmin-width: 100px;\n\t\t\t\tmax-width: 244px;\n\t\t\t}\n\n\t\t\t.table-body {\n\t\t\t\t.table-row {\n\t\t\t\t\ttd {\n\t\t\t\t\t\tborder-bottom: 1px solid var(--ion-color-primary-border);\n\t\t\t\t\t\tpadding: 0.5rem 0.625rem;\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\t\tline-height: 1.1875rem;\n\t\t\t\t\t\tcolor: var(--ion-color-primary-black);\n\n\t\t\t\t\t\t.product-img {\n\t\t\t\t\t\t\twidth: 80px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t.warehouse-data {\n\t\t\t\t\t\tpadding: 0.5rem 0.625rem;\n\t\t\t\t\t}\n\n\t\t\t\t\t.right-arrow {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t}\n\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.mobile-view-listing {\n\t\t.order-container {\n\t\t\t.order-card {\n\t\t\t\tbackground: var(--ion-color-primary-white);\n\t\t\t\tborder: 1px solid var(--ion-color-primary-border);\n\t\t\t\tborder-radius: 2px;\n\t\t\t\tmargin: 0.625rem 0;\n\n\t\t\t\t.order-card-col {\n\t\t\t\t\tpadding-top: 0.9375rem;\n\t\t\t\t}\n\n\t\t\t\t.grid-label {\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tfont-size: 0.6875rem;\n\t\t\t\t\tline-height: 0.8125rem;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tcolor: var(--ion-color-secondary-black);\n\t\t\t\t}\n\n\t\t\t\t.grid-values {\n\t\t\t\t\tpadding-top: 0.1875rem;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\tline-height: 1.1875rem;\n\t\t\t\t\tcolor: var(--ion-color-secondary-blue);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.mobile-right-arrow {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\t}\n\t\t}\n\t}\n\n}\n\n.products-number-div {\n\tfont-weight: bold;\n\tfont-size: 0.875rem;\n\tletter-spacing: 0;\n\tcolor: var(--ion-color-primary-black);\n\topacity: 1;\n\tfont-size: 0.875rem;\n}\n\n.status-btn,\n.pending,\n.shipped,\n.canceled {\n\tfont-weight: 400;\n\tmax-width: 140px;\n\tfont-size: 0.8375rem;\n\tline-height: 1.125rem;\n\tborder-radius: 4px;\n\twidth: 100%;\n\ttext-transform: capitalize;\n}\n\n.pending {\n\tbackground: rgba(109, 207, 246, 0.2);\n\tcolor: var(--ion-color-primary-blue);\n}\n\n.shipped {\n\tbackground: rgba(172, 219, 97, 0.25);\n\tcolor: var(--ion-color-green-100);\n}\n\n.canceled {\n\tbackground: rgba(233, 75, 75, 0.1);\n\tcolor: var(--ion-color-primary);\n\t;\n}\n\n.shipping,\n.partially-shipped {\n\tbackground: rgba(255, 121, 23, 0.17);\n\tcolor: var(--ion-color-primary-orange);\n}\n\n.order-card {\n\t.status-btn {\n\t\twidth: auto;\n\t\tfont-weight: 500;\n\t\tfont-size: 0.875rem;\n\t\tline-height: 0.875rem;\n\t}\n}\n\n.justify-end {\n\tjustify-content: flex-end;\n}\n\n.justify-centre {\n\tjustify-content: center;\n}\n\n.justify-start {\n\tjustify-content: flex-start;\n}\n\n\n.toggle-edit-block {\n\tion-toggle {\n\t\t// width: 43px;\n\t\t// height: 1.3125rem;\n\t\t// --handle-height: 1.0625rem;\n\t\t// --handle-width: 1.0625rem;\n\t\t--background-checked: var(--ion-color-primary);\n\t\tvertical-align: bottom;\n\t}\n\n\t.edit {\n\t\tposition: relative;\n\t\ttop: -2px;\n\t\tcursor: pointer;\n\t}\n\n\t.toggle-block-icons {\n\t\tcursor: pointer;\n\t\tvertical-align: bottom;\n\t\tfont-size: 1.25rem;\n\t\theight: 20px;\n\t\twidth: 20px;\n\t}\n}\n\n.mw-70 {\n\tmin-width: 70px;\n}\n\n.mw-80 {\n\tmin-width: 80px;\n}\n\n.mw-100 {\n\tmin-width: 100px;\n}\n\n.mw-120 {\n\tmin-width: 120px;\n}\n\n.mw-150 {\n\tmin-width: 150px;\n}\n\n.mw-200 {\n\tmin-width: 200px;\n}\n\n.button-container {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n\n.mass-upload-btn {\n\twidth: 140px;\n\theight: 46px;\n\tbackground: var(--ion-color-primary) 0% 0% no-repeat padding-box;\n\topacity: 1;\n\tfont-weight: bold;\n\tfont-size: 0.9375rem;\n\tletter-spacing: 0;\n\tcolor: var(--ion-color-primary-white);\n\ttext-transform: uppercase;\n\topacity: 1;\n}\n\n.generate-template-btn {\n\twidth: 130px;\n}\n\n.export-btn,\n.update-btn {\n\twidth: 100px;\n}\n\n.arrow-icon {\n\tcursor: pointer;\n}\n\n.isOpen {\n\timg {\n\t\ttransform: rotate(90deg);\n\t\ttransition: 0.5s ease-in-out;\n\t}\n}\n\n.isClosed {\n\timg {\n\t\ttransform: rotate(270deg);\n\t\ttransition: 0.5s ease-in-out;\n\t}\n}\n\n.inventory-modal {\n\tion-header:after {\n\t\theight: 0;\n\t}\n}\n\n.download-arrow {\n\timg {\n\t\tfilter: brightness(0) invert(1);\n\t}\n}\n\n.common-input {\n\t.modal-label {\n\t\tfont-weight: bold;\n\n\t\t.value {\n\t\t\tfont-weight: 400;\n\t\t}\n\t}\n}\n\n.icon-color {\n\tcolor: var(--ion-black-primary);\n\tfont-size: 20px;\n\tvertical-align: bottom;\n}\n\n.toggle-container {\n\theight: 1.25rem;\n\tcursor: pointer;\n}\n\n.subproduct-open {\n\tcolor: var(--ion-app-primary);\n}\n\n.arrow-column {\n\tmin-width: 30px;\n}\n\n.table-input {\n\tborder: 1px solid var(--ion-black-primary);\n\tz-index: 0;\n}\n\n.cursor-disabled {\n\tcursor: not-allowed;\n}\n\n.highlighted-row {\n\ttd {\n\t\tbackground-color: var(--ion-light-grey);\n\t}\n}\n\n.filter-container {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tpadding-bottom: 2.5rem;\n\tcolumn-gap: 0.9375rem;\n\talign-items: center;\n\twidth: 100%;\n}\n\n.filter-buttons {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tcolumn-gap: 0.625rem;\n\trow-gap: 0.625rem;\n}\n\n.from-date-div,\n.to-date-div {\n\twidth: unset;\n}\n\n.from-date-class,\n.to-date-class {\n\tmax-width: 190px;\n}\n\n.to-date-class {\n\tmargin-top: 2rem;\n}\n\n.status-label {\n\twidth: 100%;\n\tpadding-bottom: 0.625rem;\n\tfont-weight: bold;\n\ttext-transform: capitalize !important;\n\tcolor: var(--ion-color-primary-black);\n}\n\n.filter-header {\n\tpadding-bottom: 1.25rem;\n}\n\n.filter-header-ng-select {\n\tmin-width: 300px;\n}\n\n.cancel-icon {\n\twidth: 20px;\n}\n\n@include respond-below(md) {\n\t.inventory-management-container .listing-header .title-div {\n\t\tfont-size: 1.625rem;\n\t}\n\n\t.from-date-class,\n\t.to-date-class,\n\t.status-select-input {\n\t\tmax-width: 100%;\n\t\twidth: 100%;\n\t}\n\n\n}","// custom fons facemizxin\n\n@mixin font-face($font-family, $url) {\n    @font-face {\n        font-family: '#{$font-family}';\n        src: url('#{$url}.eot');\n        src: url('#{$url}.eot?#iefix') format('embedded-opentype'),\n        url('#{$url}.woff') format('woff'),\n        url('#{$url}.ttf') format('truetype'),\n        url('#{$url}.svg') format('svg');\n        font-weight: normal;\n        font-style: normal;\n    }\n}\n\n\n\n//custom font resposnive muin\n$font-base-min: 14px;\n$font-base-max: 6;\n$breakmin: 320px;\n$breakmax: 768px;\n$customSize: 5px;\n\n@mixin font-responsive($fmin, $fdiff, $breakmin, $breakdiff) {\n    font-size: calc(#{$fmin} + #{$fdiff} * ((100vw - #{$breakmin}) / #{$breakdiff}));\n\n    @media(max-width: $breakmin) {\n        font-size: $fmin;\n    }\n\n    @media(min-width: round($breakmin + $breakmax)) {\n        font-size: round($fmin + $fdiff);\n    }\n\n    @media(max-width: $breakmax) {\n        // font-size: round($fmin + 3px);\n        font-size: calc(#{$fmin} + #{$customSize});\n    }\n}\n\n\n// custom font source mmixins\n\n@mixin font($colour: false, $weight: false, $lh: false, $spacing: false) {\n\n    // @if $size { font-size: $size; }\n    @if $colour {\n        color: $colour;\n    }\n\n    @if $weight {\n        font-weight: $weight;\n    }\n\n    @if $lh {\n        line-height: $lh;\n    }\n\n    @if $spacing {\n        letter-spacing: $spacing;\n    }\n}\n\n\n// custom input placeholder mixins\n\n@mixin input-placeholder {\n    &.placeholder {\n        @content;\n    }\n\n    &:-moz-placeholder {\n        @content;\n    }\n\n    &::-moz-placeholder {\n        @content;\n    }\n\n    &:-ms-input-placeholder {\n        @content;\n    }\n\n    &::-webkit-input-placeholder {\n        @content;\n    }\n}\n\n\n// A map of breakpoints.\n$breakpoints: (\n    xs: 480px,\n    sm: 576px,\n    md: 768px,\n    lg: 992px,\n    xl: 1200px,\n    xxl: 1600px,\n    ipadSize: 768px,\n    ipadmin:481px,\n    ipadmax:1024px,\n    ipadlandscape:1320px,\n\n);\n\n// Respond above.\n@mixin respond-above($breakpoint) {\n\n    // If the breakpoint exists in the map.\n    @if map-has-key($breakpoints, $breakpoint) {\n\n        // Get the breakpoint value.\n        $breakpoint-value: map-get($breakpoints, $breakpoint);\n\n        // Write the media query.\n        @media (min-width: $breakpoint-value) {\n            @content;\n        }\n\n        // If the breakpoint doesn't exist in the map.\n    }\n\n    @else {\n\n        // Log a warning.\n        @warn 'Invalid breakpoint: #{$breakpoint}.';\n    }\n}\n\n\n\n\n@mixin respond-below($breakpoint) {\n\n    // If the breakpoint exists in the map.\n    @if map-has-key($breakpoints, $breakpoint) {\n\n        // Get the breakpoint value.\n        $breakpoint-value: map-get($breakpoints, $breakpoint);\n\n        // Write the media query.\n        @media (max-width: ($breakpoint-value - 1)) {\n            @content;\n        }\n\n        // If the breakpoint doesn't exist in the map.\n    }\n\n    @else {\n\n        // Log a warning.\n        @warn 'Invalid breakpoint: #{$breakpoint}.';\n    }\n}\n\n\n\n@mixin respond-between($lower, $upper) {\n\n    // If both the lower and upper breakpoints exist in the map.\n    @if map-has-key($breakpoints, $lower) and map-has-key($breakpoints, $upper) {\n\n        // Get the lower and upper breakpoints.\n        $lower-breakpoint: map-get($breakpoints, $lower);\n        $upper-breakpoint: map-get($breakpoints, $upper);\n\n        // Write the media query.\n        @media (min-width: $lower-breakpoint) and (max-width: ($upper-breakpoint - 1)) {\n            @content;\n        }\n\n        // If one or both of the breakpoints don't exist.\n    }\n\n    @else {\n\n        // If lower breakpoint is invalid.\n        @if (map-has-key($breakpoints, $lower)==false) {\n\n            // Log a warning.\n            @warn 'Your lower breakpoint was invalid: #{$lower}.';\n        }\n\n        // If upper breakpoint is invalid.\n        @if (map-has-key($breakpoints, $upper)==false) {\n\n            // Log a warning.\n            @warn 'Your upper breakpoint was invalid: #{$upper}.';\n        }\n    }\n}\n\n\n// @media only screen and (device-width: 768px) {}\n\n// @media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:portrait) {}\n\n// @media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:landscape) {\n//     /* For landscape layouts only */\n// }\n\n/// vernodr prefixes\n\n@mixin css3-prefix($prop, $value) {\n    -webkit-#{$prop}: #{$value};\n    -moz-#{$prop}: #{$value};\n    -ms-#{$prop}: #{$value};\n    -o-#{$prop}: #{$value};\n    #{$prop}: #{$value};\n}\n\n\n//  vertical cneter\n@mixin vertical-center {\n    position: relative;\n    top: 50%;\n    -ms-transform: translateY(-50%);\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n}\n\n//keyframe miins\n\n@mixin keyframes($name) {\n    @-webkit-keyframes #{$name} {\n        @content;\n    }\n\n    @-moz-keyframes #{$name} {\n        @content;\n    }\n\n    @keyframes #{$name} {\n        @content;\n    }\n}\n\n//absolute positoning\n\n@mixin abs-position ($top, $right, $bottom, $left) {\n    position: absolute;\n    top: $top;\n    right: $right;\n    bottom: $bottom;\n    left: $left;\n}\n\n\n//arrow minis\n@mixin arrow($direction: down, $size: 5px, $color: #555) {\n    width: 0;\n    height: 0;\n\n    @if ($direction ==left) {\n        border-top: $size solid transparent;\n        border-bottom: $size solid transparent;\n        border-right: $size solid $color;\n    }\n\n    @else if ($direction ==right) {\n        border-top: $size solid transparent;\n        border-bottom: $size solid transparent;\n        border-left: $size solid $color;\n    }\n\n    @else if ($direction ==down) {\n        border-left: $size solid transparent;\n        border-right: $size solid transparent;\n        border-top: $size solid $color;\n    }\n\n    @else {\n        border-left: $size solid transparent;\n        border-right: $size solid transparent;\n        border-bottom: $size solid $color;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
